// extracted by mini-css-extract-plugin
export default {"tableButton":"EquipmentAllocationTable_tableButton__f1hJ+","tableButtonGold":"EquipmentAllocationTable_tableButtonGold__+yuom"};